import React from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import 'animate.css/animate.min.css';
import './Hero.css';

const Hero = (props) => {
    const { orientation, backgroundImage, subTitle, title, buttonTitle, buttonTitle2, buttonTitle3, buttonType2, triangleDown } = props;
    const gradient = { color1: '#215e94', color2: 'transparent', x: '50%', y: '50%' };

    return (
        <div className={`hero ${orientation}`} style={{ backgroundImage: `url(${backgroundImage})` }}>
            <h1 className="hidden">Open HPP Job Postings</h1>
            <div className="hero-body">
                <div className="container">
                    <div className="columns">
                        <div className="column is-offset-1-tablet is-10-tablet">
                            <div className="title-wrapper animated fadeInLeft">
                                {subTitle && <div className="pre-title">{subTitle}</div>}
                                {title && <div className="big-title">{title}</div>}
                                <div className="columns">
                                    <div className="column is-12-tablet is-10-desktop is-8-widescreen">
                                        <div className='cta-wrapper'>
                                            {buttonTitle &&
                                                <Link className="btn-link button" to={props.buttonLink}>
                                                    <span>{buttonTitle}</span>
                                                </Link>}
                                            {buttonTitle2 && buttonType2 === 'internal' &&
                                                <Link className="btn-link button" to={props.buttonLink2}>
                                                    <span>{buttonTitle2}</span>
                                                </Link>}
                                            {buttonTitle2 && buttonType2 === 'external' &&
                                                <a className="btn-link button" target="_blank" rel="noopener noreferrer" href={props.buttonLink2}>
                                                    <span>{buttonTitle2}</span>
                                                </a>}
                                            {buttonTitle3 &&
                                                <a className="btn-link button" target="_blank" rel="noopener noreferrer" href={props.buttonLink3}>
                                                    <span>{buttonTitle3}</span>
                                                </a>}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {triangleDown &&
                <div className="svg-triangle">
                    <svg preserveAspectRatio="none" viewBox="0 0 100 100">
                        <polygon points="100,40 60,100 100,100" opacity="1"></polygon>
                        <defs>
                            <linearGradient id="light-to-dark-blue"
                                x1={gradient.x} y1={gradient.x}
                                x2={gradient.y} y2={gradient.y}>
                                <stop offset="0" stopColor={gradient.color1} />
                                <stop offset="1" stopColor={gradient.color2} />
                            </linearGradient>
                        </defs>
                    </svg>
                </div>
            }
        </div>
    );
};

Hero.propTypes = {
    backgroundImage: PropTypes.string,
    orientation: PropTypes.string,
    subTitle: PropTypes.string,
    title: PropTypes.object,
    buttonLink: PropTypes.string,
    buttonType2: PropTypes.string,
    buttonLink2: PropTypes.string,
    buttonLink3: PropTypes.string,
    buttonTitle: PropTypes.string,
    buttonTitle2: PropTypes.string,
    buttonTitle3: PropTypes.string,
    triangleDown: PropTypes.bool,
};

export default Hero;
